"use client"

import { Container, SimpleGrid, Box, Title, Text, Badge, Stack } from "@forestsync/ui"
import { useTranslations } from "next-intl"

export function LandingHowItWorks() {
  const t = useTranslations("landing")

  const steps = [
    { step: 1, title: t("howItWorksStep1Title"), desc: t("howItWorksStep1Desc") },
    { step: 2, title: t("howItWorksStep2Title"), desc: t("howItWorksStep2Desc") },
    { step: 3, title: t("howItWorksStep3Title"), desc: t("howItWorksStep3Desc") },
  ]

  return (
    <Box py={80} bg="var(--mantine-color-body)">
      <Container size="lg">
        <Title order={2} ta="center" mb="xl">{t("howItWorksTitle")}</Title>
        <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl">
          {steps.map(({ step, title, desc }) => (
            <Stack key={step} gap="sm" align="flex-start">
              <Badge size="lg" radius="xl" color="forest" variant="filled">
                {step}
              </Badge>
              <Title order={4}>{title}</Title>
              <Text size="sm" c="dimmed" lh={1.7}>{desc}</Text>
            </Stack>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
